import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Copy, Check, Share2 } from 'lucide-react';
import toast from 'react-hot-toast';
import Modal from '../ui/Modal';
import ShareKitQuickBar from './ShareKitQuickBar';
import { useLanguage } from '../../contexts/LanguageContext';
import { copyTextToClipboard } from '../../utils/clipboard';

function ShortActionShareModal({ open, onClose, url, message }) {
  const { t, formatMessage } = useLanguage();
  const sa = t.enrola.shortActions;
  const shareText = message || formatMessage(t.enrola.defaultShareFallback, { url });
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    if (!url) return;
    try {
      await copyTextToClipboard(url);
      setCopied(true);
      toast.success(sa.linkCopied);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t.enrola.copyFailed);
    }
  };

  return (
    <Modal isOpen={open} onClose={onClose} title={sa.shareTitle} size="default">
      <div className="space-y-6">
        <div className="flex items-start gap-3 rounded-2xl bg-gradient-to-br from-orange-500/10 via-amber-500/5 to-transparent p-4 ">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-md shadow-orange-500/30">
            <Share2 className="h-5 w-5" />
          </div>
          <p className="text-sm leading-relaxed text-secondary-600 ">{sa.shareSubtitle}</p>
        </div>

        <div>
          <p className="mb-2 micro text-secondary-400">{sa.yourLink}</p>
          <div className="flex gap-2 rounded-2xl border border-secondary-200/80 bg-secondary-50/60 p-3  ">
            <p className="min-w-0 flex-1 break-all text-sm font-medium text-secondary-800 ">
              {url}
            </p>
            <motion.button
              type="button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={copyLink}
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors ${
                copied
                  ? 'bg-success-500 text-white'
                  : 'bg-secondary-900 text-white hover:bg-orange-600 '
              }`}
            >
              {copied ? <Check className="h-5 w-5" /> : <Copy className="h-5 w-5" />}
            </motion.button>
          </div>
        </div>

        <div>
          <p className="stat-label mb-3">{t.enrola.shareQuick}</p>
          <ShareKitQuickBar url={url} message={shareText} />
        </div>
      </div>
    </Modal>
  );
}

export default ShortActionShareModal;
